/**
 * ErrorBanner — the canonical inline error treatment.
 *
 * One consistent rose-toned banner (icon + message), never a raw text line
 * or an alert(). Renders nothing when there's no message, so pages can drop
 * `<ErrorBanner message={error} />` unconditionally.
 */
import { AlertTriangle } from 'lucide-react'
import { clsx } from 'clsx'

export default function ErrorBanner({
  message,
  className,
}: {
  message?: string | null
  className?: string
}) {
  if (!message) return null
  return (
    <div
      role="alert"
      className={clsx('card p-2 text-[11px] text-rose-light flex items-center gap-2', className)}
    >
      <AlertTriangle size={14} className="shrink-0" /> {message}
    </div>
  )
}
